// extracted by mini-css-extract-plugin
export default {"main":"PrivacyPolicy_main__PCAFA","title":"PrivacyPolicy_title__qQe7C","text":"PrivacyPolicy_text__+lfzV"};